import type React from "react";

export type IconSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
export type IconColor =
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "warning"
  | "info"
  | "muted"
  | "current";

type IconWrapperProps = {
  size?: IconSize;
  color?: IconColor;
  className?: string;
  children: React.ReactNode;
};

const sizeClasses: Record<IconSize, string> = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-10 h-10",
};

const colorClasses: Record<IconColor, string> = {
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  error: "text-error",
  warning: "text-warning",
  info: "text-info",
  muted: "text-muted-foreground",
  current: "text-current",
};

export function IconWrapper(props: IconWrapperProps) {
  const size = props.size || "md";
  const color = props.color || "current";
  const className = props.className || "";

  const sizeClass = sizeClasses[size];
  const colorClass = colorClasses[color];

  return (
    <span className={`inline-block ${sizeClass} ${colorClass} ${className}`}>
      {props.children}
    </span>
  );
}
